const SpeakNormalizer = (codes) => {
  for (const code of codes) {
    if (!code.startsWith("<speak")) {
      throw new Error("存在未设置属性的段落");
    }
  }
  return codes;
};

export { SpeakNormalizer };
//# sourceMappingURL=speak-normalizer.js.map
